import React, { useEffect, useRef } from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/Signup";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./components/LandingPage";
import AccessDenied from "./components/Auth/AccessDenied";
import Admin from "./components/AuditLogs/Admin";
import UserProfile from "./components/Auth/UserProfile";
import ForgotPassword from "./components/Auth/ForgotPassword";
import OAuth2RedirectHandler from "./components/Auth/OAuth2RedirectHandler";
import { Toaster } from "react-hot-toast";
import NotFound from "./components/NotFound";
import ContactPage from "./components/contactPage/ContactPage";
import AboutPage from "./components/aboutPage/AboutPage";
import ResetPassword from "./components/Auth/ResetPassword";
import Footer from "./components/Footer/Footer";
import TimesheetTable from "./components/TimesheetTable/TimesheetTable";
import PastTimesheets from "./components/PastTimesheets/PastTimesheets";
import { setupInterceptors } from "./services/api_config";
import { useMyContext } from "./store/ContextApi";
import { useTheme } from "./store/ThemeContext";

const App = () => {
  const { token, refreshAccessToken, logout } = useMyContext();
  const { theme } = useTheme();
  const tokenRef = useRef(token);
  const isDark = theme === "dark";

  useEffect(() => {
    tokenRef.current = token;
  }, [token]);

  useEffect(() => {
    setupInterceptors(() => tokenRef.current, refreshAccessToken, logout);
  }, [refreshAccessToken, logout]);

  return (
    <Router>
      <Navbar />
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        toastOptions={{
          style: {
            background: isDark ? "#1e293b" : "#ffffff",
            color: isDark ? "#f1f5f9" : "#0f172a",
            border: isDark ? "1px solid #334155" : "1px solid #e2e8f0",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route
          path="/timesheetsthismonth"
          element={
            <ProtectedRoute>
              <TimesheetTable />
            </ProtectedRoute>
          }
        />

        <Route
          path="/timesheets/past"
          element={
            <ProtectedRoute>
              <PastTimesheets />
            </ProtectedRoute>
          }
        />

        <Route
          path="/timesheets/:payrollCycleId"
          element={
            <ProtectedRoute>
              <TimesheetTable />
            </ProtectedRoute>
          }
        />

        <Route path="/access-denied" element={<AccessDenied />} />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute adminPage={true}>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <UserProfile />
            </ProtectedRoute>
          }
        />
        <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
